<div class="dialog {{type}}">
  {{message}}
  <span (click)="closeClick()" class="close-thik"></span>
</div>